export function getIsValidOriginInAuthCompletedEvent(origin: string): boolean {
  return origin === location.origin;
}
